export default {
  en: {
    tools: {
      aerodrome: {
        cardtitle: 'Aerodromes',
        carddescription: 'Find any ICAO aerodrome in the world.',
        desc: 'This tool allows you to search for aerodromes by ICAO code or name. You can also search for aerodromes by their location.',
        meta: {
          title: 'Aerodrome search',
          desc: 'Search for aerodromes by ICAO code or name and get their runways, frequencies and more.',
        },
        searchlabel: 'Aerodrome (ICAO, IATA, name or location)',
        min: '3 characters minimum',
      },
      frequency: {
        cardtitle: 'Frequencies',
        carddescription: 'Find the correct frequencies.',
        desc: 'Search for frequencies by aerodromes, VORs, NDBs and other radio stations by ICAO code, IATA code, name or location.',
        meta: {
          title: 'Frequency search',
          desc: 'Search for frequencies by aerodromes, VORs, NDBs and other radio stations by ICAO code, IATA code, name or location.',
        },
        searchlabel: 'Frequencies (118.000 MHz - 136.975 MHz)',
        min: '3 characters minimum',
      }
    }
  },
  de: {
    tools: {
      aerodrome: {
        cardtitle: 'Flughäfen',
        carddescription: 'Finde jeden ICAO-Flughafen der Welt.',
        desc: 'Dieses Tool ermöglicht es dir, nach Flughäfen anhand des ICAO-Codes oder Namens zu suchen. Du kannst auch nach Flughäfen anhand ihres Standorts suchen.',
        meta: {
          title: 'Flughafensuche',
          desc: 'Suche nach Flughäfen anhand des ICAO-Codes oder Namens und erhalte Informationen zu Start- und Landebahnen, Frequenzen und mehr.',
        },
        searchlabel: 'Flughafen (ICAO, IATA, Name oder Standort)',
        min: 'Mindestens 3 Zeichen',
      },
      frequency: {
        cardtitle: 'Frequenzen',
        carddescription: 'Finde die richtigen Frequenzen.',
        desc: 'Suche nach Frequenzen von Flughäfen, VORs, NDBs und anderen Funkstationen anhand des ICAO-Codes, IATA-Codes, Namens oder Standorts.',
        meta: {
          title: 'Frequenzensuche',
          desc: 'Suche nach Frequenzen von Flughäfen, VORs, NDBs und anderen Funkstationen anhand des ICAO-Codes, IATA-Codes, Names oder Standorts.',
        },
        searchlabel: 'Frequenzen (118.000 MHz - 136.975 MHz)',
        min: 'Mindestens 3 Zeichen',
      }
    }
  },
  at: {},
  es: {
    tools: {
      aerodrome: {
        cardtitle: 'Aeródromos',
        carddescription: 'Encuentra cualquier aeródromo ICAO en el mundo.',
        desc: 'Esta herramienta te permite buscar aeródromos por código ICAO o nombre. También puedes buscar aeródromos por su ubicación.',
        meta: {
          title: 'Búsqueda de aeródromos',
          desc: 'Busca aeródromos por código ICAO o nombre y obtén información sobre sus pistas, frecuencias y más.',
        },
        searchlabel: 'Aeródromo (ICAO, IATA, nombre o ubicación)',
        min: 'Mínimo 3 caracteres',
      },
      frequency: {
        cardtitle: 'Frecuencias',
        carddescription: 'Encuentra las frecuencias correctas.',
        desc: 'Busca frecuencias por aeródromos, VORs, NDBs y otras estaciones de radio por código ICAO, código IATA, nombre o ubicación.',
        meta: {
          title: 'Búsqueda de frecuencias',
          desc: 'Busca frecuencias por aeródromos, VORs, NDBs y otras estaciones de radio por código ICAO, código IATA, nombre o ubicación.',
        },
        searchlabel: 'Frecuencias (118.000 MHz - 136.975 MHz)',
        min: 'Mínimo 3 caracteres',
      }
    }
  },
  uk: {
    tools: {
      aerodrome: {
        cardtitle: 'Аеродроми',
        carddescription: 'Знайдіть будь-який аеродром ICAO у світі.',
        desc: 'Цей інструмент дозволяє шукати аеродроми за кодом ICAO або назвою. Ви також можете шукати аеродроми за їхнім розташуванням.',
        meta: {
          title: 'Пошук аеродромів',
          desc: 'Шукайте аеродроми за кодом ICAO або назвою та отримуйте інформацію про їхні злітно-посадкові смуги, частоти та інше.',
        },
        searchlabel: 'Аеродром (ICAO, IATA, назва або розташування)',
        min: 'Мінімум 3 символи',
      },
      frequency: {
        cardtitle: 'Частоти',
        carddescription: 'Знайдіть правильні частоти.',
        desc: 'Шукайте частоти аеродромів, VOR, NDB та інших радіостанцій за кодом ICAO, кодом IATA, назвою або розташуванням.',
        meta: {
          title: 'Пошук частот',
          desc: 'Шукайте частоти аеродромів, VOR, NDB та інших радіостанцій за кодом ICAO, кодом IATA, назвою або розташуванням.',
        },
        searchlabel: 'Частоти (118.000 МГц - 136.975 МГц)',
        min: 'Мінімум 3 символи',
      }
    }
  }
}
